import React from "react";
import NewsletterFormPage from "../components/newsletters/NewsletterFormPage";

const NewsletterCreate = () => <NewsletterFormPage mode="create" />;

export default NewsletterCreate;
